import React from "react";
import {Box, Button, Stack, Text} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import {INTL_FIND_MORE} from "../../../../translations/blogs";
import {INTL_CHAT_WITH} from "../../../../translations/mentorCard";
import {isFunction} from "../../../../util/isFunction";

type BlogChatToAmbassadorButtonProps = {
    name: string;
    onChatNow: () => void;
};

export const BlogChatToAmbassadorButton = ({name, onChatNow}: BlogChatToAmbassadorButtonProps) => {
    const {t} = useTranslation();

    return (
        <Box
            borderRadius={"xxsmall"}
            borderColor={"var(--theme-primary)"}
            borderWidth={1}
            padding="medium"
            width="100%"
            minW={200}
        >
            <Stack space={"medium"} align={"center"}>
                <Text weight={600} size={"medium"} align={"center"}>
                    {t(
                        `${INTL_FIND_MORE.namespace}:${INTL_FIND_MORE.key}`,
                        INTL_FIND_MORE.defaultValue,
                    )}
                </Text>
                <Button color="university" onClick={onChatNow}>
                    {t(
                        `${INTL_CHAT_WITH.namespace}:${INTL_CHAT_WITH.key}`,
                        isFunction(INTL_CHAT_WITH.defaultValue)
                            ? INTL_CHAT_WITH.defaultValue(name)
                            : INTL_CHAT_WITH.defaultValue,
                        {name},
                    )}
                </Button>
            </Stack>
        </Box>
    );
};
